import uniq from 'lodash/uniq';
import { createReducer } from 'typesafe-actions';
import { type Actions, getLatestDeploys, publishSite, saveSite } from './actions.js';
import type { Deploy, DeploysAction, DeploysMap, PublishingAction, SitesState } from './types.js';

export const initialSitesState: SitesState = {
  isSaving: false,
  publishing: [],
  latestDeploys: {},
  latestDeploysLoading: false,
  latestDeploysLoaded: false,
  latestDeploysError: null
};

function addToPublishing(state: SitesState, { meta }: PublishingAction): SitesState {
  return {
    ...state,
    publishing: uniq(state.publishing.concat(meta.siteId))
  };
}

function removeFromPublishing(state: SitesState, { meta }: PublishingAction): SitesState {
  return {
    ...state,
    publishing: state.publishing.filter((siteId) => siteId !== meta.siteId)
  };
}

export function createLatestDeploysMap(deploys: Deploy[]): DeploysMap {
  return deploys.reduce((result: DeploysMap, item: Deploy): DeploysMap => {
    result[item.siteId] = item.timestamp;
    return result;
  }, {});
}

export default createReducer<SitesState, Actions>(initialSitesState)
  .handleType(saveSite.PENDING, (state: SitesState) => ({
    ...state,
    isSaving: true
  }))
  .handleType(saveSite.FULFILLED, (state: SitesState) => ({
    ...state,
    isSaving: false
  }))
  .handleType(saveSite.REJECTED, (state: SitesState) => ({
    ...state,
    isSaving: false
  }))
  .handleType(getLatestDeploys.PENDING, (state: SitesState) => ({
    ...state,
    latestDeploysLoading: true,
    latestDeploysError: null
  }))
  .handleType(getLatestDeploys.FULFILLED, (state: SitesState, { payload }: DeploysAction) => ({
    ...state,
    latestDeploys: createLatestDeploysMap(payload?.sites ?? []),
    latestDeploysError: null,
    latestDeploysLoading: false,
    latestDeploysLoaded: true
  }))
  .handleType(getLatestDeploys.REJECTED, (state: SitesState, { payload }: DeploysAction) => ({
    ...state,
    latestDeploysError: payload?.message ?? 'An error occurred',
    latestDeploysLoading: false
  }))
  .handleType(publishSite.REQUESTED, addToPublishing)
  .handleType(publishSite.PENDING, addToPublishing)
  .handleType(publishSite.FULFILLED, removeFromPublishing)
  .handleType(publishSite.REJECTED, removeFromPublishing);
